import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import MButton from '../../../MUI/Button/MButton';
import MDialog from '../../../atoms/MDialog/MDialog';

const ConfirmationModal = ({ isConfirmedModalOpened, closeConfirmedModal, updateSettings }) => {
  return (
    <MDialog
      fullWidth
      minWidth="630px"
      title="Auto Invoicing Dates Changed"
      titleVariant="h4"
      isOpen={isConfirmedModalOpened}
      onClose={closeConfirmedModal}
      footerActions={
        <>
          <MButton variant="secondary" size="large" onClick={updateSettings}>
            Update Dates
          </MButton>
          <MButton size="large" onClick={closeConfirmedModal}>
            Cancel
          </MButton>
        </>
      }
    >
      <Typography variant="bodyL500" pb="32px">
        You have modified one or more dates for Automated Invoicing.
      </Typography>
      <Typography variant="bodyL500" pb="32px">
        The affected invoices will be automatically exported to QuickBooks on the selected day of
        every month at 5 AM (Arizona time).
      </Typography>
      <Typography variant="bodyL500" pb="32px">
        These changes will enter into effect starting from the next month.
      </Typography>
      <Typography variant="bodyL500" pb="8px">
        Are you sure you want to save the changes?
      </Typography>
    </MDialog>
  );
};

ConfirmationModal.propTypes = {
  isConfirmedModalOpened: PropTypes.func.isRequired,
  closeConfirmedModal: PropTypes.func.isRequired,
  updateSettings: PropTypes.func.isRequired,
};

export default ConfirmationModal;
